import * as UI from '@brewlogix/blx-ui'
import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import Image from 'next/image'
import getDefaultIconByProduct from 'src/util/helpers/getDefaultIconByProduct'

const MainImage: React.FC = () => {
    const { assets, productData } = useBrewDetailStore()
    const defaultIcon = getDefaultIconByProduct(productData)
    const image =
        assets?.length > 0 ? (
            <UI.Media
                asset={assets[0]}
                customWrapperClasses='rounded-lg'
                width={400}
                height={400}
                alt={`Logo Image for ${productData?.title}`}
            />
        ) : (
            <div className='flex items-center justify-center rounded-lg'>
                <Image
                    src={defaultIcon}
                    alt={`Default ${productData?.__typename} Icon`}
                    width={500}
                    height={500}
                />
            </div>
        )
    return image
}

export default MainImage
